import { Injectable } from '@angular/core';

import { ClientConfigProductName, LazyClientConfig, LazyClientConfigBase, LazyClientConfigService } from '@frontend/vanilla/core';

import { GlobalMetaTagsRule, PageMetaTagsRule } from './meta-tags.models';

@LazyClientConfig({ key: 'vnMetaTags', product: ClientConfigProductName.SF })
@Injectable({
    providedIn: 'root',
    deps: [LazyClientConfigService],
    useFactory: metaTagsConfigFactory,
})
export class MetaTagsConfig extends LazyClientConfigBase {
    pageMetaTags: PageMetaTagsRule[];
    globalMetaTags: GlobalMetaTagsRule[];
}

export function metaTagsConfigFactory(service: LazyClientConfigService) {
    return service.get(MetaTagsConfig);
}
